module.exports = __webpack_public_path__ + "img/publicSecurity2.d0289dc0.png";